import { render, staticRenderFns } from "./ItemPlanner.vue?vue&type=template&id=92e552aa&scoped=true&"
import script from "./ItemPlanner.vue?vue&type=script&lang=js&"
export * from "./ItemPlanner.vue?vue&type=script&lang=js&"
import style0 from "./ItemPlanner.vue?vue&type=style&index=0&id=92e552aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e552aa",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BForm, BCardText, BCard} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BForm, BCardText, BCard})
    

export default component.exports